module.exports = __webpack_public_path__ + "img/2.7dd2c944.svg";